module.exports = __webpack_public_path__ + "img/57.1.0eb4b0ec.jpg";